function waitForElement(selector, callback) {
  const interval = setInterval(function() {
    const element = document.querySelector(selector);
    if (element) {
      clearInterval(interval);
      callback(element);
    }
  }, 300); // 每300毫秒檢查一次
}

document.addEventListener("DOMContentLoaded", function() {
    // 撰寫評價修改文字
    waitForElement('.yotpo-body-text', function(titleElement) {
      titleElement.textContent = '尚無評價，要立即寫一則嗎？';
    });
  
    waitForElement('.yotpo-new-review-btn', function(reviewBtnElement) {
      reviewBtnElement.textContent = '撰寫評價';
    });
});

// footer新增常見問題
document.addEventListener("DOMContentLoaded", function() {
  // 找到目標 ul
  const footerList = document.querySelector(".footer-block__details-content.list-unstyled");
  if (!footerList) return;

  // 建立新的 li 元素
  const newLi = document.createElement("li");
  newLi.innerHTML = `
    <a href="/pages/faqs" class="link link--text list-menu__item list-menu__item--link">
      常見問題
    </a>
  `;

  // 插入到最後面
  footerList.appendChild(newLi);
});

// 新增文章總覽頁
document.addEventListener('DOMContentLoaded', function () {
  const blogSection = document.querySelector('[id^="Slider-template--"][id*="featured_blog"]');
  if (!blogSection) return;

  const sliderComponent = blogSection.closest('slider-component');
  const sectionWrapper = sliderComponent?.parentElement;
  const titleWrapper = sectionWrapper?.querySelector('.title-wrapper-with-link');

  if (!sliderComponent || !titleWrapper) return;
  if (titleWrapper.querySelector('.blog-read-more-link')) return;

  const readMoreLink = document.createElement('a');
  readMoreLink.href = 'https://rorastudios.tw/blogs/journals';
  readMoreLink.className = 'blog-read-more-link';
  readMoreLink.textContent = 'Read more';

  titleWrapper.appendChild(readMoreLink);
});

// 常見問題動態
document.addEventListener('DOMContentLoaded', function() {

  const rows = document.querySelectorAll('.summary-collapse-row');

  rows.forEach(function(row) {

    row.addEventListener('click', function() {

      const content = row.nextElementSibling;

      if (
        !content ||
        !content.classList.contains('collapse-accordion-content')
      ) {
        return;
      }

      const isOpen = row.classList.contains('is-open');

      rows.forEach(function(otherRow) {

        otherRow.classList.remove('is-open');

        const otherContent = otherRow.nextElementSibling;

        if (
          otherContent &&
          otherContent.classList.contains('collapse-accordion-content')
        ) {
          otherContent.style.maxHeight = '0px';
        }

      });

      if (!isOpen) {
        row.classList.add('is-open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }

    });

  });

});

// 拿掉『已包含稅額』字樣
function removeTaxNote() {
  const taxNote = document.querySelector('small.tax-note');
  if (taxNote) taxNote.remove();
}

document.addEventListener('DOMContentLoaded', removeTaxNote);
setTimeout(removeTaxNote, 1000);

// 拿掉『估計』2字
function updateTotalTitle() {
  document.querySelectorAll('.totals__total').forEach(el => {
    if (el.textContent.includes('估計總金額')) {
      el.textContent = '總金額';
    }
  });
}

updateTotalTitle();

const observer = new MutationObserver(updateTotalTitle);
observer.observe(document.body, {
  childList: true,
  subtree: true
});